import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';
import localeEs from '@angular/common/locales/es';
import localeFr from '@angular/common/locales/fr';
import localeIt from '@angular/common/locales/it';
import localeNl from '@angular/common/locales/nl';
import localeFi from '@angular/common/locales/fi';
import localePt from '@angular/common/locales/pt';
import localeHu from '@angular/common/locales/hu';
import localeRu from '@angular/common/locales/ru';
import localePl from '@angular/common/locales/pl';
import localeSv from '@angular/common/locales/sv';
import localeDa from '@angular/common/locales/da';
import localeZh from '@angular/common/locales/zh';
import localeRo from '@angular/common/locales/ro';
import localeNo from '@angular/common/locales/no';
import localeCs from '@angular/common/locales/cs';
import localeTh from '@angular/common/locales/th';

export function registerLocales(){
  registerLocaleData(localeDe);
  registerLocaleData(localeEn);
  registerLocaleData(localeEs);
  registerLocaleData(localeFr);
  registerLocaleData(localeIt);
  registerLocaleData(localeNl);
  registerLocaleData(localeFi);
  registerLocaleData(localePt);
  registerLocaleData(localeHu);
  registerLocaleData(localeRu);
  registerLocaleData(localePl);
  registerLocaleData(localeSv);
  registerLocaleData(localeDa);
  registerLocaleData(localeZh);
  registerLocaleData(localeRo);
  registerLocaleData(localeNo);
  registerLocaleData(localeCs);
  registerLocaleData(localeTh);
}
